export const sidebar = {
  header: {
    menu: "MENU",
  },
  items: {
    home: "Home",
    reservations: "Bookings",
    calendar: "Calendar",
    hourlyCalendar: "By the hour",
    calls: "Calls",
    aiReception: "AI reception",
    availabilityRates: "Availability & rates",
    checkins: "Check-ins",
    channels: "Booking channels",
    inbox: "Inbox",
    settings: "Settings",
    experiences: "Experiences",
    scheduleCall: "Schedule a call",
    support: "Support",
    novedades: "What's new",
    messages: "Messages",
    badgeNew: "New",
    invoicing: "Invoicing",
    customers: "Customers",
    clientsDirectory: "Clients",
    fiscalCustomers: "Tax customers",
    invoices: "Invoices",
    housekeeping: "Housekeeping",
    analytics: "Analytics",
  },
  alt: {
    logo: "Logo",
  },
};
